import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinbhor() {



  const cardData =
  {
    keyword: 'Cab Service in Bhor',
    heading: 'Sanavi Travels: Cab Service in Bhor',
    headingDescription: 'Cab Service in Bhor offers reliable, comfortable, and affordable taxi solutions for local travel, outstation trips, airport transfers, and special journeys such as weddings, corporate travel, and religious tours. Choose from a wide range of well-maintained vehicles including Swift Dzire, Etios, Ertiga, Innova Crysta, and luxury SUVs, all driven by professional chauffeurs. With on-time pickup, transparent fares, flexible packages, and 24/7 customer support, cab service in Bhor ensures a smooth, safe, and hassle-free travel experience to Pune, Mumbai, Mahabaleshwar, Konkan, Goa, and other nearby destinations.',

    top: 'Top Places to Visit in Bhor with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhor Town",
    "description": "Bhor is a historic town in Pune district, once the capital of the former Bhor princely state. Nestled in the Sahyadri ranges, the town is known for its pleasant climate, rich cultural heritage, and scenic surroundings. Bhor offers a peaceful blend of history, rural life, and natural beauty, making it a calm retreat away from crowded tourist destinations."
  },
  {
    "title": "Bhor Rajwada (Royal Palace)",
    "description": "The Bhor Rajwada is a reminder of the town’s princely past. This heritage structure reflects traditional Maratha-era architecture and stands as a symbol of Bhor’s historical importance. Though simple in design, it gives visitors insight into the royal legacy and governance of the region."
  },
  {
    "title": "Bhatghar Dam",
    "description": "Bhatghar Dam is one of the oldest masonry dams in India, built on the Yelwandi River. Surrounded by hills and greenery, the dam creates a vast reservoir that offers stunning views, especially during the monsoon season. It is a popular spot for nature lovers, photographers, and those seeking quiet scenic escapes."
  },
  {
    "title": "Neera River Valley",
    "description": "The Neera River flows near Bhor, forming fertile valleys and scenic landscapes. The riverbanks are ideal for short walks, picnics, and enjoying peaceful moments amidst nature. During monsoon, the valley turns lush green, enhancing the beauty of the region."
  },
  {
    "title": "Baneshwar Temple and Forest",
    "description": "Located near Bhor, Baneshwar Temple is an ancient Shiva temple surrounded by a protected forest area. The Baneshwar forest is rich in biodiversity and offers nature trails, picnic spots, and a tranquil environment. The temple is especially vibrant during Mahashivratri celebrations."
  },
  {
    "title": "Varandha Ghat",
    "description": "Varandha Ghat is a scenic mountain pass connecting Bhor to Mahad in the Konkan region. Known for its breathtaking views, waterfalls, and deep valleys, the ghat is a favorite route for monsoon drives, bikers, and nature enthusiasts."
  },
  {
    "title": "Raireshwar Temple",
    "description": "Raireshwar Temple, located near Bhor, is historically significant as the place where Chhatrapati Shivaji Maharaj took an oath of Swarajya. Dedicated to Lord Shiva, the temple sits atop a hill and offers panoramic views along with deep spiritual and historical importance."
  },
  {
    "title": "Hill Treks and Nature Trails",
    "description": "The hills surrounding Bhor provide excellent opportunities for trekking, hiking, and nature walks. Trails pass through forests, streams, and open plateaus, making them ideal for adventure seekers and nature lovers, especially during the monsoon season."
  },
  {
    "title": "Village Life and Rural Culture",
    "description": "Bhor’s surrounding villages reflect authentic rural Maharashtrian culture. Visitors can experience traditional farming practices, local festivals, warm hospitality, and simple village life set against a scenic natural backdrop."
  },
  {
    "title": "Sunset Viewpoints",
    "description": "Several viewpoints around Bhor offer mesmerizing sunset views over hills, rivers, and valleys. These spots are perfect for relaxation, photography, and enjoying the calm beauty of the Sahyadri landscape."
  }
]
,



"services": [
{
"name": "Cab Service in Bhor",
"description": "Cab Service in Bhor offers reliable and comfortable taxi services for local travel, sightseeing, and outstation trips. With well-maintained vehicles, professional drivers, and flexible booking options, it ensures a smooth, safe, and timely journey. Ideal for families, tourists, corporate travelers, and daily commuters, it prioritizes customer satisfaction, convenience, and a hassle-free travel experience across Bhor and nearby areas."
},
{
"name": "Taxi Service Bhor",
"description": "Taxi Service Bhor provides efficient and professional cab services for city travel, airport transfers, and outstation journeys. With punctual pickups, courteous drivers, and modern vehicles, it offers a convenient and stress-free transportation solution for residents, tourists, and business travelers in and around Bhor."
},
{
"name": "AC Cab Bhor",
"description": "AC Cab Bhor ensures a comfortable and refreshing travel experience with fully air-conditioned vehicles. Ideal for long-distance trips, family outings, and corporate travel, these cabs provide a smooth ride, modern interiors, and professional drivers who prioritize safety and convenience for passengers traveling in Bhor."
},
{
"name": "Local Cab Bhor",
"description": "Local Cab Bhor provides quick, reliable, and affordable taxi services for intra-city travel, shopping trips, and sightseeing. With professional drivers, timely pickups, and well-maintained vehicles, it ensures a safe, convenient, and hassle-free journey within Bhor city limits and nearby areas."
},
{
"name": "Outstation Cab Bhor",
"description": "Outstation Cab Bhor specializes in long-distance travel to nearby cities, tourist destinations, and hill stations. Comfortable vehicles, skilled drivers, and flexible itineraries ensure safe, convenient, and enjoyable journeys for families, groups, and solo travelers exploring locations beyond Bhor."
},
{
"name": "Affordable Cab Bhor",
"description": "Affordable Cab Bhor delivers budget-friendly taxi services without compromising on comfort, safety, or reliability. Ideal for daily commuters, families, tourists, and corporate travelers, it combines economical pricing with professional drivers and well-maintained vehicles, making it a dependable choice for cost-conscious passengers in Bhor."
},
{
"name": "Chauffeur Driven Cab Bhor",
"description": "Chauffeur Driven Cab Bhor provides professional drivers who manage navigation, traffic, and schedules, allowing passengers to relax and enjoy a stress-free journey. Perfect for VIP clients, corporate teams, families, and tourists, it ensures smooth, safe, and comfortable travel across Bhor and surrounding areas."
},
{
"name": "Best Cab Service Bhor",
"description": "Best Cab Service Bhor is known for its punctuality, well-maintained vehicles, and excellent customer service. Offering city travel, airport transfers, sightseeing, and outstation trips, it provides reliable, safe, and comfortable transportation for individuals, families, and corporate clients in Bhor."
},
{
"name": "Tourist Cab Bhor",
"description": "Tourist Cab Bhor caters to travelers exploring Bhor and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable vehicles, it provides a seamless sightseeing experience, allowing tourists to enjoy cultural, historical, and scenic destinations without worrying about transportation logistics."
},
{
"name": "Airport Cab Bhor",
"description": "Airport Cab Bhor offers timely and convenient pickups and drop-offs to and from airports. With professional drivers, well-maintained vehicles, and real-time scheduling, it ensures passengers reach their flights comfortably and on time, making it a reliable choice for both domestic and international travelers."
},
{
"name": "Corporate Cab Bhor",
"description": "Corporate Cab Bhor provides professional and efficient taxi services for executives, employees, and business teams. With punctual pickups, clean vehicles, and courteous drivers, it ensures safe, reliable, and stress-free transportation for office travel, meetings, airport transfers, and corporate events in and around Bhor."
},
{
"name": "Online Cab Booking Bhor",
"description": "Online Cab Booking Bhor allows passengers to reserve cabs quickly and conveniently with instant confirmation. Multiple vehicle options, transparent pricing, and flexible scheduling make trip planning easy and hassle-free for families, corporate clients, tourists, and local commuters traveling in Bhor."
},
{
"name": "Family Cab Bhor",
"description": "Family Cab Bhor provides spacious, safe, and comfortable vehicles suitable for family travel. Designed to accommodate all age groups, it ensures smooth and enjoyable journeys for family outings, vacations, and day trips within Bhor and surrounding areas."
},
{
"name": "24x7 Taxi Bhor",
"description": "24x7 Taxi Bhor offers round-the-clock taxi services for emergency travel, late-night pickups, airport transfers, and unplanned trips. With reliable drivers, well-maintained vehicles, and instant availability, it ensures passengers can travel safely and comfortably at any time of day or night."
},
{
"name": "Bhor Travel Taxi",
"description": "Bhor Travel Taxi delivers comprehensive cab services for local commuting, tourist travel, and outstation trips. Combining comfort, safety, affordability, and professional service, it caters to families, tourists, and corporate travelers seeking dependable and convenient transportation in Bhor and nearby areas."
}
],
"tableData": [
["Cab Service in Bhor", "Taxi Service Bhor"],
["AC Cab Bhor", "Local Cab Bhor"],
["Outstation Cab Bhor", "Affordable Cab Bhor"],
["Chauffeur Driven Cab Bhor", "Best Cab Service Bhor"],
["Tourist Cab Bhor", "Airport Cab Bhor"],
["Corporate Cab Bhor", "Online Cab Booking Bhor"],
["Family Cab Bhor", "24x7 Taxi Bhor"],
["Bhor Travel Taxi", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Bhor with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Bhor for local travel, airport transfers, sightseeing, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well‑Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air‑conditioned, and kept clean to ensure a smooth and pleasant ride throughout Bhor."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Bhor routes, ensuring safe, timely, and stress‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Bhor, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, hourly hires, airport transfers, and outstation cab packages based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Bhor."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Bhor?',
    answer: 'Yes, Sanavi Travels offers dependable cab services in Bhor for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Bhor?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab services are available in Bhor?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Bhor.'
  },
  {
    question: 'Are the drivers experienced with routes in Bhor?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Bhor area and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Bhor.'
  },
  {
    question: 'Is the cab service in Bhor available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock cab services in Bhor to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab ride in Bhor.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manoj Shinde',
    feedback: 'Booked a cab in Bhor with Sanavi Travels — excellent service, clean vehicle, and friendly driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja More',
    feedback: 'Great cab service in Bhor with prompt pickup and smooth ride. Highly recommended!',
    rating: 5
  }
];























































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Cab Service in Bhor - Sanavi Travels",
  "description": "Sanavi Travels provides AC and affordable cabs in Bhor for local rides, outstation trips, airport transfers, corporate travel, family trips, and tourist journeys. 24x7 chauffeur-driven service with online booking available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "38"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Cab Service in Bhor | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and affordable cabs in Bhor with Sanavi Travels. Perfect for local trips, outstation travel, airport pickups, corporate rides, family trips, and tourist journeys. 24x7 chauffeur-driven service with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/144.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinbhor;